module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Book-5b9174bc04691a46e8498cf0693ef8d120335cf25229265cce6a42f2b5fe99a9.svg";